import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from '@themesberg/react-bootstrap';

const PRIZES = [
  { label: 'Giải đặc biệt', count: 1, digits: 5 },
  { label: 'Giải nhất', count: 1, digits: 5 },
  { label: 'Giải nhì', count: 2, digits: 5 },
  { label: 'Giải ba', count: 6, digits: 5 },
  { label: 'Giải tư', count: 4, digits: 4 },
  { label: 'Giải năm', count: 6, digits: 4 },
  { label: 'Giải sáu', count: 3, digits: 3 },
  { label: 'Giải bảy', count: 4, digits: 2 },
]

const emptyLines = () => PRIZES.map(prize => Array(prize.count).fill(''))
const emptySymbols = () => Array(6).fill('')

export default (props) => {
  const [lines, setLines] = useState(emptyLines)
  const [symbols, setSymbols] = useState(emptySymbols)

  useEffect(() => {
    const next = emptyLines()
    if (props.result && props.result.length > 0) {
      props.result.forEach((line, index) => {
        if (!next[index]) return
        const parts = `${line || ''}`.trim().split(/\s+/).filter(Boolean)
        parts.forEach((part, partIndex) => {
          if (partIndex < next[index].length) next[index][partIndex] = part
        })
      })
    }
    setLines(next)
    const stored = `${props.symbol || ''}`.split('|').map(part => part.trim().toUpperCase())
    setSymbols(emptySymbols().map((value, index) => stored[index] || value))
  }, [props.result, props.symbol, props.id])

  const onSymbolChange = (index, value) => {
    const cleaned = value.toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 2)
    setSymbols(prev => prev.map((item, itemIndex) => itemIndex === index ? cleaned : item))
  }

  const onChange = (prizeIndex, numberIndex, value) => {
    const digits = PRIZES[prizeIndex].digits
    const cleaned = value.replace(/\D/g, '').slice(0, digits)
    setLines(prev => prev.map((row, index) => {
      if (index !== prizeIndex) return row
      return row.map((cell, cellIndex) => cellIndex === numberIndex ? cleaned : cell)
    }))
  }

  return (
    <Modal {...props} size="xl" centered onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Kết quả Miền Bắc</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Label>Ký hiệu giải đặc biệt (6 ký hiệu)</Form.Label>
              <Row className="justify-content-center">
                {symbols.map((value, index) => (
                  <Col md={2} className="mb-2" key={`symbol-${index}`}>
                    <Form.Control
                      value={value}
                      disabled
                      onChange={(event) => onSymbolChange(index, event.target.value)}
                    />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          {PRIZES.map((prize, prizeIndex) => (
            <Row key={prize.label}>
              <Col md={12} className="mb-2">
                <Form.Label>{prize.label} ({prize.digits} số)</Form.Label>
                <Row className="justify-content-center">
                  {lines[prizeIndex].map((value, numberIndex) => (
                    <Col md={3} className="mb-2" key={`${prize.label}-${numberIndex}`}>
                      <Form.Control
                        value={value}
                        inputMode="numeric"
                        disabled
                        onChange={(event) => onChange(prizeIndex, numberIndex, event.target.value)}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}
